export function defaultRegisterStateBuilder(uuid, payload) {
    // could be a problem when login from success page, u will get redirected after register to /bewerben again #future
    const redirectSuccessActionUrl = new URL('/bewerben', window.location.origin);
    redirectSuccessActionUrl.searchParams.set('uuid', uuid);
    redirectSuccessActionUrl.searchParams.set('payload', payload);

    // Build the action that will be executed after login
    const action = {
        type: 'redirectAfterRegister',
        redirectSuccess: redirectSuccessActionUrl,
        fallbackUrl: redirectSuccessActionUrl,
    };

    // For registering, we need to send state parameter, so we encrypt the action with base64
    return btoa(JSON.stringify(action));
}
